const SESSION_SYSTEM = "SEMESTER"
const SITE_NAME = "OATutor"
const CONTENT_SOURCE = "oatutor"

module.exports = {
    SESSION_SYSTEM,
    SITE_NAME,
    CONTENT_SOURCE
}
